import React from 'react';
import { FaFacebookF, FaInstagram, FaLinkedinIn, FaYoutube, } from "react-icons/fa";
import '../../assets/css/footerstyle.css';
import {Link} from 'react-router-dom';
// import Expo from '../Common/Expo';

const Footer = () => {

return(
   <>


 <footer id="footer" className=" bg-gray-900 text-white footer">
    <div className="container" style={{ maxWidth:"1192px"}}>
      <div className="flex flex-wrap">
        <div className="w-full lg:w-1/3 mb-0 borderight">
          <h4 className="text-sm font-normal mb-2 color-gray-300"> Information </h4>
          <ul className="text-sm space-y-1 pl-0">
            <li><Link to="/about" className="capitalize color-gray-400 text-decoration-none"> About Us</Link></li>
            <li><Link to="/privacy" className="capitalize color-gray-400 text-decoration-none"> Loyalty Points Terms & Conditions</Link></li>
            <li><Link to="/loyalty" className="capitalize color-gray-400 text-decoration-none"> Privacy Policy</Link></li>
          </ul>
        </div>

        <div className="w-full lg:w-1/3 mb-0 borderight paddingLeftSide">
          <h4 className="text-sm font-normal mb-2 color-gray-300 "> Contact Address </h4>
          <ul className="text-sm space-y-1 pl-0">
            <li style={{ fontWeight:"600", color:'#d4d4d4'}}> En’Vogue Furnishings India Pvt. Ltd </li>
            <li className="color-gray-400">
              <div style={{display:"flex", gap:"8px"}}> 
              <i className="bi bi-geo-alt iii-icon" style={{ fontSize:"16px"}}></i> 
              <span> 20, Pusa Road, <br />
              New Delhi, Central Delhi, <br />
              Delhi 110005 India
              </span>
              </div>
            </li>
            <li className='color-gray-400' style={{ marginTop:"9px"}}> <i className="bi bi-card-list iii-icon" style={{ fontSize:"16px"}}></i>&nbsp; <strong className='iii-icon'>CIN :</strong> U74994DL2004PTC124979</li>
          </ul>
        </div>

        <div className="w-full lg:w-1/3 mb-0 paddingLeftSide">
                   
       <div style={{display:"flex", flexDirection:"column", paddingTop:"28px"}}> 
        <div className="w-full">
          <div className="mt-0">
            <div className="text-sm flex items-center gap-2 color-gray-300">
              <i className="bi bi-telephone ii-icon" style={{ fontSize:"15px"}}></i>
              1800-3000-3200
            </div>
          </div>
        </div>


        <div className="w-full">
          <div className="mt-1 text-sm flex items-center gap-2">
            
            <i className="bi bi-envelope-at ii-icon"  style={{ fontSize:"15px"}}></i>
            <a href="mailto:contact@obsessions.co.in" className="text-gray-300 color-gray-300 text-decoration-none">contact@obsessions.co.in</a>
          </div>
        </div>


        <div className="w-full flex items-left" style={{ flexDirection:"column", marginTop:"13px", borderTop:"1px solid #464545", paddingTop:"7px"}}>
          <span className="text-sm mr-2 color-gray-300 iii-icon" style={{ fontWeight:"500", marginBottom:"5px"}}> Follow us on social Networks </span>
              <div className="social-icons">
                      <Link to="https://www.facebook.com/obsessionsindia" className="facebook" target="_blank" rel="noopener noreferrer">
                        <FaFacebookF />
                      </Link>

                      <Link to="https://www.instagram.com/obsessionsindia/" className="instagram" target="_blank" rel="noopener noreferrer">
                        <FaInstagram />
                      </Link>

                       <Link href="https://in.linkedin.com/in/obsessions-india-520090174" className="youtube" target="_blank" rel="noopener noreferrer">
                          <FaYoutube />
                      </Link>

                      <Link href="https://in.linkedin.com/in/obsessions-india-520090174" className="linkedin" target="_blank" rel="noopener noreferrer">
                        <FaLinkedinIn />
                      </Link>

                      
                </div>

             </div>
          </div>
          
        </div>
      </div>
    </div>
     </footer>

       <div className='copyright'>  
       <p className="text-center text-gray-400 text-xs m-0 pb-2">
        &copy; 2026 obsession.co.in | All Rights Reserved.
      </p>

     </div>

      {/* <Expo/> */}

   </>
  
  )
 }
 export default Footer;